import { create } from 'zustand'

const PANEL_MESSAGES: Record<string, string> = {
  scanner: 'Building the perfect scan...',
  'multi-scanner': 'Building the perfect scan...',
  watchlist: 'Setting up your watchlist...',
  chart: 'Configuring your chart...',
  news: 'Tuning your news feed...',
  'key-stats': 'Loading key stats...',
  'ticker-stats': 'Analyzing ticker stats...',
  'bar-chart': 'Configuring your chart...',
  calendar: 'Setting up your calendar...',
  notebook: 'Organizing your notes...',
}

interface PanelActivityState {
  /** Panel ID currently being modified by AI */
  activePanelId: string | null
  /** Message to display on the panel */
  message: string | null

  /** Start showing activity on a panel */
  startActivity: (panelId: string, panelType?: string) => void
  /** Clear the activity indicator */
  clearActivity: () => void
}

export const usePanelActivityStore = create<PanelActivityState>((set) => ({
  activePanelId: null,
  message: null,

  startActivity: (panelId, panelType) => {
    const message = (panelType && PANEL_MESSAGES[panelType]) || 'Making changes...'
    set({ activePanelId: panelId, message })
  },

  clearActivity: () => {
    set({ activePanelId: null, message: null })
  },
}))

export function getActivityMessage(panelType: string): string {
  return PANEL_MESSAGES[panelType] || 'Making changes...'
}
